import React from "react";

const FortellisSubtitle1 = ({ subtitle }) => {
  return <div className="fortellis-subtitle-1">{subtitle}</div>;
};

export default FortellisSubtitle1;
